/* eslint-disable no-redeclare */
/* eslint-disable no-loop-func */

import { isFunc } from './CreateStore';
import update from '@mbernal/simple-immutable';

//Requirements
//CreateStore.js must have the following code

/*
    function getState() {P
        return _model;
    }

    Object.keys(events).forEach((key) => {
        const evt = events[key];

        if (evt instanceof UpdateBuilder) {
            events[key] = evt.build();
        }
    });

/*


Examples

    action: dispatch("UPDATE_INPUT",{b:{inputValue:'UPDATED'}});

    Event on Store:
    ["UPDATE_INPUT"]:withPayload("b.inputValue")
                    .setValues(["name","nameAlso","nestedName.c"])
                    .setTrue("bool")
                    .setValuess("id","CUSTOM_ID")
    },

Initial State:
    {
        id:null,
        bool:false,
        name:null,
        nameAlso:null,
        nestedName:{
            c:null
        }
    }
)

New State:
    {
        id:CUSTOM_ID,
        bool:true,
        name:UPDATED,
        nameAlso:UPDATED,
        nestedName:{
            c:UPDATED
        }
    }
*/

const deepValue = function (obj, path) {
  for (var i = 0, path = path.split('.'), len = path.length; i < len; i++) {
    if (Array.isArray(obj[path[i]] && path.length > 1)) {
      obj = obj[path[i]][path[i + 1]];
      i++;
    } else {
      obj = obj[path[i]];
    }
  }
  ;
  return obj;
};
export class UpdateBuilder {
  constructor() {
    this._updates = {};
    this._readables = {};
    this._payload = false;
    this._payloadProp = null;
    this._payloadHistory = {};
  }
  build() {
    return (action, state) => {
      const updateActions = this.runUpdates(action, state);
      if (Object.keys(updateActions).length === 0) {
        return state;
      }
      return update(state, updateActions);
    };
  }
  _getPayloadValue(name, payload) {
    const history = this._payloadHistory[name];
    if (history) {
      const value = deepValue(payload, history);
      return value;
    }
    return payload;
  }
  _setPayloadHistory(name) {
    if (this._payload && !this._payloadHistory.hasOwnProperty(name)) {
      this._payloadHistory[name] = this._payloadProp;
    }
  }
  _getValue(name, fn, action, state) {
    return fn && isFunc(fn) ? fn(action.payload, state) : this._payloadHistory.hasOwnProperty(name) ? this._getPayloadValue(name, action.payload) : fn;
  }
  _resetPayload() {
    this._payload = false;
    this._payloadProp = null;
  }
  runUpdates(action, state) {
    const ret = {};
    for (var prop in this._readables) {
      if (!this._readables.hasOwnProperty(prop)) continue;
      this._readables[prop](action, state);
    }
    for (var prop in this._updates) {
      if (!this._updates.hasOwnProperty(prop)) continue;
      const result = this._updates[prop](action, state);
      if (result === null) {
        continue;
      }
      ret[result.prop] = result.value;
    }
    return ret;
  }

  //This will only apply to the next chain call and then clear
  withPayload(prop) {
    this._payload = true;
    this._payloadProp = prop;
    return this;
  }
  setTrue(prop) {
    prop = Array.isArray(prop) ? prop : [prop];
    for (let i = 0; i < prop.length; i++) {
      const p = prop[i];
      this._updates[`setTrue:${p}`] = (action, state) => {
        return {
          prop: [`set ${p}`],
          value: true
        };
      };
    }
    return this;
  }
  setFalse(prop) {
    prop = Array.isArray(prop) ? prop : [prop];
    for (let i = 0; i < prop.length; i++) {
      const p = prop[i];
      this._updates[`setFalse:${p}`] = (action, state) => {
        return {
          prop: [`set ${p}`],
          value: false
        };
      };
    }
    return this;
  }
  setValues(prop, fn) {
    prop = Array.isArray(prop) ? prop : [prop];
    for (let i = 0; i < prop.length; i++) {
      const p = prop[i];
      const name = `setValues:${p}`;
      this._setPayloadHistory(name);
      this._updates[name] = (action, state) => {
        let value = this._getValue(name, fn, action, state);
        if (value === undefined) {
          return {};
        }
        return {
          prop: [`set ${p}`],
          value: value !== null && value[p] ? value[p] : value
        };
      };
    }
    this._resetPayload();
    return this;
  }
  togglePropsOn(prop, fn) {
    prop = Array.isArray(prop) ? prop : [prop];
    for (let i = 0; i < prop.length; i++) {
      const p = prop[i];
      const name = `togglePropsOn:${p}`;
      this._setPayloadHistory(name);
      this._updates[name] = (action, state) => {
        const value = this._getValue(name, fn, action, state);
        return {
          prop: [`togglePropsOn ${p}`],
          value: [value]
        };
      };
    }
    this._resetPayload();
    return this;
  }
  setStore(fn) {
    const name = `setStore`;
    this._setPayloadHistory(name);
    this._updates[name] = (action, state) => {
      const value = this._getValue(name, fn, action, state);
      return {
        prop: 'set',
        value: value
      };
    };
    this._resetPayload();
    return this;
  }
  mergeStore(fn) {
    const name = `mergeStore`;
    this._setPayloadHistory(name);
    this._updates[name] = (action, state) => {
      const value = this._getValue(name, fn, action, state);
      if (value === undefined || value === null) return null;
      return {
        prop: 'merge',
        value: value
      };
    };
    this._resetPayload();
    return this;
  }
  merge(prop, fn) {
    if (!prop) return this.mergeStore();
    prop = Array.isArray(prop) ? prop : [prop];
    for (let i = 0; i < prop.length; i++) {
      const p = prop[i];
      const name = `merge:${p}`;
      this._setPayloadHistory(name);
      this._updates[name] = (action, state) => {
        const value = this._getValue(name, fn, action, state) || {};
        if (value && Array.isArray(value) && value.length) {
          if (value[0].hasOwnProperty("id")) {
            const stateProp = state[p];
            const newArray = Array.isArray(stateProp) ? stateProp.slice() : [];
            value.forEach((item, i) => {
              const matchIndex = newArray.findIndex(match => match.id === item.id);
              if (matchIndex < 0) {
                newArray.push(item);
              } else {
                newArray[matchIndex] = item;
              }
            });
            return {
              prop: [`set ${p}`],
              value: newArray
            };
          }
        } else if (isFunc(fn)) {
          const newArray = [];

          //Handle Array and Object
          const stateArray = Array.isArray(state[p]) ? state[p] : Object.values(state[p]);
          stateArray.forEach(item => {
            let fnValue = null;
            if (fnValue = fn(item, value)) {
              newArray.push(fnValue);
              return;
            }
            ;
            newArray.push(item);
          });
          return {
            prop: [`set ${p}`],
            value: newArray
          };
        }
        return {
          prop: [`merge ${p}`],
          value: value[p] ? value[p] : value
        };
      };
    }
    this._resetPayload();
    return this;
  }
  pushTo(prop, fn) {
    prop = Array.isArray(prop) ? prop : [prop];
    for (let i = 0; i < prop.length; i++) {
      const p = prop[i];
      const name = `push:${p}`;
      this._setPayloadHistory(name);
      this._updates[name] = (action, state) => {
        let value = this._getValue(name, fn, action, state);
        if (value === undefined) {
          console.error(`StoreUtils.push: Error attempting to push a store value without calling withPayload() or a static value push(value))`, name, state);
          value = null;
        }
        if (!Array.isArray(value)) {
          value = [value];
        }
        return {
          prop: [`push ${p}`],
          value: value !== null && value[p] ? value[p] : value
        };
      };
    }
    this._resetPayload();
    return this;
  }
  mergeObjById(prop, fn) {
    prop = Array.isArray(prop) ? prop : [prop];
    for (let i = 0; i < prop.length; i++) {
      const p = prop[i];
      const name = `mergeObjById:${p}`;
      this._setPayloadHistory(name);
      this._updates[name] = (action, state) => {
        let index;
        const payloadValue = this._getValue(name, null, action, state);
        for (let i = 0; i < state[p].length; i++) {
          const item = state[p][i];
          index = i;
          if (!fn && item.id === payloadValue.id) {
            index = i;
            break;
          } else if (isFunc(fn) && fn(item, payloadValue)) {
            index = i;
            break;
          }
        }
        if (index === undefined || index === null) {
          console.warning(`StoreUtils.mergeObjById: Unable to find store object with id ${payloadValue.id}`, name, state);
          return {};
        }
        return {
          prop: [`merge ${p}.${index}`],
          value: payloadValue !== null && payloadValue[p] ? payloadValue[p] : payloadValue
        };
      };
    }
    this._resetPayload();
    return this;
  }
  unsetPropsOn(prop, fn) {
    prop = Array.isArray(prop) ? prop : [prop];
    for (let i = 0; i < prop.length; i++) {
      const p = prop[i];
      const name = `setValues:${p}`;
      this._setPayloadHistory(name);
      this._updates[name] = (action, state) => {
        let value = this._getValue(name, fn, action, state);
        if (value === undefined) {
          value = null;
        }
        return {
          prop: [`unsetPropsOn ${p}`],
          value: value[p] ? [value[p]] : [value]
        };
      };
    }
    this._resetPayload();
    return this;
  }
  ifTrue(fn) {
    const name = 'ifTrue';
    this._updates[name] = (action, state) => {
      if (fn(action, state)) {
        return state;
      }
      return null;
    };
    this._resetPayload();
    return this;
  }
  removeFrom(prop, fn) {
    prop = Array.isArray(prop) ? prop : [prop];
    for (let i = 0; i < prop.length; i++) {
      const p = prop[i];
      const name = `remove:${p}`;
      this._setPayloadHistory(name);
      this._updates[name] = (action, state) => {
        let value = [];
        let payloadValue = this._getValue(name, null, action, state);
        payloadValue = Array.isArray(payloadValue) ? payloadValue : [payloadValue];
        value = state[p].filter((child, i) => {
          if (isFunc(fn) && fn(child, payloadValue)) {
            return false;
          } else if (!fn && payloadValue.find(payloadChild => payloadChild === child)) {
            return false;
          } else if (payloadValue.find(payloadChild => payloadChild[fn] === child[fn])) {
            return false;
          }
          return true;
        });
        if (value === undefined) {
          console.error(`StoreUtils.remove: Error attempting to remove a store value without calling withPayload() or a static value remove(value))`, name, state);
          value = null;
        }
        if (value === null) return {};
        return {
          prop: [`set ${p}`],
          value: value
        };
      };
    }
    this._resetPayload();
    return this;
  }
  toggleBoolean(prop) {
    prop = Array.isArray(prop) ? prop : [prop];
    for (let i = 0; i < prop.length; i++) {
      const p = prop[i];
      this._updates[`toggleBoolean:${p}`] = (action, state) => {
        const value = deepValue(state, prop);
        return {
          prop: [`set ${p}`],
          value: !value
        };
      };
    }
    return this;
  }
}
export const updateStore = () => {
  return new UpdateBuilder();
};
export const pushTo = prop => {
  return updateStore().pushTo(prop);
};
export const removeFrom = prop => {
  return updateStore().removeFrom(prop);
};
export const setTrue = prop => {
  return updateStore().setTrue(prop);
};
export const withPayload = prop => {
  return updateStore().withPayload(prop);
};
export const ifTrue = fn => {
  return updateStore().ifTrue(fn);
};
export const setFalse = prop => {
  return updateStore().setFalse(prop);
};
export const togglePropsOn = (prop, fn) => {
  return updateStore().togglePropsOn(prop, fn);
};
export const setValues = (prop, fn) => {
  return updateStore().setValues(prop, fn);
};
export const unsetPropsOn = (prop, fn) => {
  return updateStore().unsetPropsOn(prop, fn);
};
export const setStore = fn => {
  return updateStore().setStore(fn);
};
export const mergeStore = fn => {
  return updateStore().mergeStore(fn);
};
export const merge = prop => {
  return updateStore().merge(prop);
};
export const toggleBoolean = prop => {
  return updateStore().toggleBoolean(prop);
};